import { useQuery } from "@apollo/react-hooks";
import { MY_HR_GET_PAYCARD_LIST_BY_CONTRACT } from "my-hr/graphql";
import { MY_HR_GET_LAST_PAYCARD_DATA_BY_CONTRACT } from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyHrPayrollData = ({
  contract,
  year,
}: {
  contract: string;
  year: string;
}) => {
  const { data, loading, error } = useQuery(
    MY_HR_GET_PAYCARD_LIST_BY_CONTRACT,
    {
      fetchPolicy: "cache-and-network",
      skip: !contract || !year,
      variables: { contractCode: contract, year },
    },
  );

  const { data: lastPaycardData } = useQuery(
    MY_HR_GET_LAST_PAYCARD_DATA_BY_CONTRACT,
    {
      skip: !contract,
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      variables: { contractCode: contract },
    },
  );

  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  type PayCardDataType = {
    __typename: string;
    month: string;
    netWage: number;
    otherBenefits: number;
    allTaxDeductions: number;
    otherDeductions: number;
    grossWage: number;
    [key: string]: any; // Add this if there are additional fields
  };

  let queryResult: PayCardDataType[] = data?.getPaycardListByContract || [];
  let result = months.map((month) => {
    let newItem: PayCardDataType = {
      __typename: "PayCardDataType",
      month: month,
      netWage: 0,
      otherBenefits: 0,
      allTaxDeductions: 0,
      otherDeductions: 0,
      grossWage: 0,
    };
    let existMonth = queryResult.find(
      (item: PayCardDataType) => item.month === month,
    );
    return existMonth || newItem;
  });

  return {
    data: result,
    lastPaycardData: lastPaycardData?.getLastPaycardDataByContract,
    loading,
    error,
  };
};

export default useMyHrPayrollData;
